<template>
  <table class="d-table">
    <thead>
    <th colspan="8">
      {{ user.vName }}
    </th>
    </thead>
    <tbody>
    <tr class="tr__header" v-if="user.vFag.length > 0">
      <td>Fag</td>
      <td></td>
      <td>Lærerklokketimer</td>
      <td class="klokketime-td">Lærerklokketimer type</td>
    </tr>
    <tr v-if="user.vFag.length < 1">
      <td colspan="8" class="text-explainer">
        Brugeren har ingen fag
      </td>
    </tr>
    <tr v-for="fag in user.vFag">
      <td>
        <div class="subject">
          {{ fag.fag_navn }} ({{ fag.klasse_klokketimer }})
        </div>
      </td>
      <td style="width: 100%">
        {{ fag.klassebetegnelse }}
      </td>
      <td>
        <input
          type="text"
          class="d-input__small"
          @focus="$event.target.select()"
          @keyup.enter="updateStilKlasseFagLaerer(user, fag, 'klokketimer', $event.target.value, $event.target)"
          @blur="updateStilKlasseFagLaerer(user, fag, 'klokketimer', $event.target.value, $event.target)"
          :value="fag.learer_klokketimer"/>
      </td>
      <td>
        <select class="d-select__small"
                @change="updateStilKlasseFagLaerer(user, fag, 'klokketimer_type', $event.target.value)"
                :value="fag.klokketimer_type">
          <option v-for="(type, key) in klokketimetyper" :value="key">{{ type }}</option>
        </select>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import eventbus from '../../../eventbus'

export default {
  props: {
    user: {
      type: Object,
      default: () => null
    },
    dbStilData: {
      type: Object,
      default: () => {
      }
    },
    klokketimetyper: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    isValidNumber (input) {
      if (isNaN(input)) {
        return false
      }
      if (input < 0) {
        return false
      }
      return true
    },
    updateStilKlasseFagLaerer (user, itemFag, prop, val, target) {
      if (prop === 'klokketimer') {
        if (target) {
          target.classList.remove('d-input__small--warning')
        }
        if (!Number.isInteger(Number(val))) {
          window.alert('Klokketimer skal være et helt tal')
          target.classList.add('d-input__small--warning')
          return
        }
      }
      const report = JSON.parse(JSON.stringify(this.dbStilData))
      const klasseIdx = report.klasser.findIndex(klasse => klasse.klasse_id === itemFag.klasse_id)
      const fagIdx = report.klasser[klasseIdx].fag.findIndex(fag => fag.fag_id === itemFag.fag_id)
      const teacherIdx = report.klasser[klasseIdx].fag[fagIdx]['laerere'].findIndex(teacher => teacher.cpr === itemFag.cpr)
      const oldValue = report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop]
      if (oldValue === val) {
        return
      }
      report.klasser[klasseIdx].fag[fagIdx]['laerere'][teacherIdx][prop] = val
      if (prop === 'klokketimer' && !this.isValidNumber(val)) {
        eventbus.toast = {text: 'Skal være et tal, 0 eller højere', success: false}
        target.value = oldValue
        return
      }
      this.$emit('updateStil', report)
    }
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  max-width: 1100px;
  border-radius: 4px;
}

.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table.d-table__subjects tbody tr.tr--one {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
}

.d-table tbody tr.tr__header {
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  color: #728195;
}

.d-table tbody tr:not(.tr__header):hover {
  background: aliceblue !important;
}

.d-table thead {
  border: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th {
  padding: 0.5rem 1rem;
  text-align: left;
  color: #222;
}

.d-table tbody tr {
  background: #ffffff;
  width: 100%;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr td:first-child {
  padding-left: 2rem;
}

.d-table tbody tr.tr__header td:first-child {
  padding-left: 2rem;
}

.d-table tbody tr:nth-child(even) {
  background: #fbfbfb;
}

.d-table tbody tr td {
  padding: 0.25rem 1rem;
  text-align: left;
}

input[type="number"] {
  max-width: 65px;
  padding: 0.5rem 0.75rem;
  text-align: center;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

select,
input[type="text"] {
  height: 36px;
  background-color: #ffffff;
  border-radius: 4px;
  min-width: 100px;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  border: 1px solid #d8d8d8;
}

.d-table input[type="text"] {
  width: 100% !important;
}

.d-table tbody tr.tr--one {
  background: #fbfbfb;
  position: relative;
}

.d-table tbody tr.tr__header td {
  padding: 0rem 1rem;
}


.d-select__small,
.d-input__small {
  height: 28px !important;
}

.d-select__small {
  width: 265px !important;
}

.d-input__small {
  width: 65px !important;
  min-width: 65px !important;
  text-align: center;
}

.text-explainer {
  font-weight: normal !important;
}

.text-explainer__error {
  border: 1px solid #ccc;
  padding: 4rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal !important;
}

.text-explainer__error .tw-icon {
  width: 3rem;
  margin-right: 1rem;
}

.subject {
  width: 165px;
  display: inline-block;
  border-radius: 4px;
  padding: 0px 8px;
  background: transparent;
  border: 1px solid #ccc;
  font-weight: bold;
}

.klokketime-td {
  min-width: 165px;
}

td select {
  width: 100% !important;
}

.d-input__small.d-input__small--warning {
  border: 1px solid red!important;
}

</style>



// WEBPACK FOOTER //
// KompetenceIndberetningDaekningUser.vue?7e6732c7